var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 6C1.25 4.48122 2.48122 3.25 4 3.25H7C7.41421 3.25 7.75 3.58579 7.75 4C7.75 4.41421 7.41421 4.75 7 4.75H4C3.30964 4.75 2.75 5.30964 2.75 6V9C2.75 9.41421 2.41421 9.75 2 9.75C1.58579 9.75 1.25 9.41421 1.25 9V6Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 6C22.75 4.48122 21.5188 3.25 20 3.25H17C16.5858 3.25 16.25 3.58579 16.25 4C16.25 4.41421 16.5858 4.75 17 4.75H20C20.6904 4.75 21.25 5.30964 21.25 6V9C21.25 9.41421 21.5858 9.75 22 9.75C22.4142 9.75 22.75 9.41421 22.75 9V6Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20.75C2.48122 20.75 1.25 19.5188 1.25 18V15C1.25 14.5858 1.58579 14.25 2 14.25C2.41421 14.25 2.75 14.5858 2.75 15V18C2.75 18.6904 3.30964 19.25 4 19.25H7C7.41421 19.25 7.75 19.5858 7.75 20C7.75 20.4142 7.41421 20.75 7 20.75H4Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 18C22.75 19.5188 21.5188 20.75 20 20.75H17C16.5858 20.75 16.25 20.4142 16.25 20C16.25 19.5858 16.5858 19.25 17 19.25H20C20.6904 19.25 21.25 18.6904 21.25 18V15C21.25 14.5858 21.5858 14.25 22 14.25C22.4142 14.25 22.75 14.5858 22.75 15V18Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.5993C11.1742 10.5993 10.5048 11.2265 10.5048 12.0001C10.5048 12.7737 11.1742 13.4009 12 13.4009C12.8257 13.4009 13.4951 12.7737 13.4951 12.0001C13.4951 11.2265 12.8257 10.5993 12 10.5993Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3937 10.4953C19.2021 11.3705 19.2021 12.6296 18.3937 13.5049C17.0338 14.9773 14.6782 17.0001 12 17.0001C9.32184 17.0001 6.96621 14.9773 5.60629 13.5049C4.79792 12.6296 4.79792 11.3705 5.60629 10.4953C6.96621 9.02286 9.32184 7.00006 12 7.00006C14.6782 7.00006 17.0338 9.02286 18.3937 10.4953ZM8.92069 12.0001C8.92069 13.5934 10.2993 14.885 12 14.885C13.7006 14.885 15.0792 13.5934 15.0792 12.0001C15.0792 10.4068 13.7006 9.11517 12 9.11517C10.2993 9.11517 8.92069 10.4068 8.92069 12.0001Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview);
export default __webpack_public_path__ + "static/media/preview.f4c634a0dce4e95f36f0891ae24d9337.svg";
export { ForwardRef as ReactComponent };